// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PromoCard_cardWrapper__c8GNP, .PromoCard_cardWrapperLarge__upSrq, .PromoCard_cardOuterWrapper__InV5I {
    display: flex;
    justify-content: space-between;
}

.PromoCard_cardWrapper__c8GNP, .PromoCard_cardWrapperLarge__upSrq {
    border: 1px solid var(--color-lightui-surface-4);
    border-radius: 8px;
}

.PromoCard_cardWrapper__c8GNP {
    width: 100%;
    background-color: var(--color-lightui-surface-1);
}

.PromoCard_cardWrapperLarge__upSrq {
    flex-direction: column;
}


.PromoCard_cardMain__iEeZH {
    width: 100%;
    padding: 16px 16px 16px 12px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 4px;
}

.PromoCard_cardLargeMain__g1DF- {
    padding: 0 16px 16px 16px;
    background-color: var(--color-lightui-surface-1);
    border-radius: 0 0 8px 8px;
}


.PromoCard_cardDismissIcon__B8cj0 {
    height: 20px;
    width: 20px;
    margin: 16px;
    opacity: 75%;
    cursor: pointer;
    background-color: var(--color-lightui-accent-1);
    border-radius: 50%;
    z-index: 1;
}

.PromoCard_cardDismissIcon__B8cj0 {
    display: flex;
    align-items: center;
    justify-content: center;
}

.PromoCard_cardImage__G-oWn {
    width: auto;
    display: flex;
    justify-content: flex-end;
    background-position: center top;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 0 8px 8px 0;
    margin-right: -1px;
}

@media only screen and (max-width: 47.9375em) {
    .PromoCard_cardImage__G-oWn {
        background-image: none !important;
        width: auto !important;
    }
}

.PromoCard_cardImage__G-oWn::before {
    background-image: linear-gradient(to bottom, rgba(245, 246, 252, 0.52), rgba(117, 19, 93, 0.73));
}

.PromoCard_cardImage__G-oWn img {
    border-radius: 0 8px 8px 0;
}

.PromoCard_cardImageLarge__VSrHO {
    min-height: 180px;
    display: flex;
    justify-content: flex-end;
    border-radius: 8px 8px 0 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
}

.PromoCard_cardImageLarge__VSrHO img {
    width: 100%;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}


.PromoCard_cardIconContainer__qA-VC {
    width: 36px;
    padding: 16px 0 16px 16px;
    box-sizing: border-box;
}

.PromoCard_cardIcon__INJYV {
    height: 20px;
    width: 20px;
}

.PromoCard_cardIconImage__JWvIz {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}


.PromoCard_cardTitle__ssr4n {
    font-size: 14px;
    font-weight: 700;
    line-height: 21px;
    margin: 0 12px 0px 0;
    color: var(--color-darkui-surface-1);
    cursor: default;
    align-content: center;
}

.PromoCard_cardLargeTitle__Hbdns {
    font-size: 32px;
    font-weight: 300;
    line-height: 34px;
    color: var(--color-darkui-surface-1);
    margin: 0 0 7px 0;
    cursor: default;
}


.PromoCard_cardLargeSubtitle__KmO7f {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    color: var(--color-darkui-surface-1);
    margin: 0 0 15px 0;
    cursor: default;
}

.PromoCard_cardAction__HX0Wy {
    align-content: center;
}

.PromoCard_cardAction__HX0Wy, .PromoCard_cardAction__HX0Wy button {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
}

.PromoCard_cardAction__HX0Wy button {
    display: contents;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/PromoCard/PromoCard.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gDAAgD;IAChD,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gDAAgD;AACpD;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,WAAW;IACX,4BAA4B;IAC5B,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,gDAAgD;IAChD,0BAA0B;AAC9B;;;AAGA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,+CAA+C;IAC/C,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,+BAA+B;IAC/B,4BAA4B;IAC5B,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI;QACI,iCAAiC;QACjC,sBAAsB;IAC1B;AACJ;;AAEA;IACI,gGAAgG;AACpG;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,0BAA0B;IAC1B,sBAAsB;IACtB,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,4BAA4B;AAChC;;;AAGA;IACI,WAAW;IACX,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,oCAAoC;IACpC,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oCAAoC;IACpC,iBAAiB;IACjB,eAAe;AACnB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".cardWrapper, .cardWrapperLarge, .cardOuterWrapper {\n    display: flex;\n    justify-content: space-between;\n}\n\n.cardWrapper, .cardWrapperLarge {\n    border: 1px solid var(--color-lightui-surface-4);\n    border-radius: 8px;\n}\n\n.cardWrapper {\n    width: 100%;\n    background-color: var(--color-lightui-surface-1);\n}\n\n.cardWrapperLarge {\n    flex-direction: column;\n}\n\n\n.cardMain {\n    width: 100%;\n    padding: 16px 16px 16px 12px;\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    gap: 4px;\n}\n\n.cardLargeMain {\n    padding: 0 16px 16px 16px;\n    background-color: var(--color-lightui-surface-1);\n    border-radius: 0 0 8px 8px;\n}\n\n\n.cardDismissIcon {\n    height: 20px;\n    width: 20px;\n    margin: 16px;\n    opacity: 75%;\n    cursor: pointer;\n    background-color: var(--color-lightui-accent-1);\n    border-radius: 50%;\n    z-index: 1;\n}\n\n.cardDismissIcon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.cardImage {\n    width: auto;\n    display: flex;\n    justify-content: flex-end;\n    background-position: center top;\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 0 8px 8px 0;\n    margin-right: -1px;\n}\n\n@media only screen and (max-width: 47.9375em) {\n    .cardImage {\n        background-image: none !important;\n        width: auto !important;\n    }\n}\n\n.cardImage::before {\n    background-image: linear-gradient(to bottom, rgba(245, 246, 252, 0.52), rgba(117, 19, 93, 0.73));\n}\n\n.cardImage img {\n    border-radius: 0 8px 8px 0;\n}\n\n.cardImageLarge {\n    min-height: 180px;\n    display: flex;\n    justify-content: flex-end;\n    border-radius: 8px 8px 0 0;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center top;\n}\n\n.cardImageLarge img {\n    width: 100%;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n}\n\n\n.cardIconContainer {\n    width: 36px;\n    padding: 16px 0 16px 16px;\n    box-sizing: border-box;\n}\n\n.cardIcon {\n    height: 20px;\n    width: 20px;\n}\n\n.cardIconImage {\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n}\n\n\n.cardTitle {\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 21px;\n    margin: 0 12px 0px 0;\n    color: var(--color-darkui-surface-1);\n    cursor: default;\n    align-content: center;\n}\n\n.cardLargeTitle {\n    font-size: 32px;\n    font-weight: 300;\n    line-height: 34px;\n    color: var(--color-darkui-surface-1);\n    margin: 0 0 7px 0;\n    cursor: default;\n}\n\n\n.cardLargeSubtitle {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 21px;\n    color: var(--color-darkui-surface-1);\n    margin: 0 0 15px 0;\n    cursor: default;\n}\n\n.cardAction {\n    align-content: center;\n}\n\n.cardAction, .cardAction button {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 20px;\n}\n\n.cardAction button {\n    display: contents;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardWrapper": `PromoCard_cardWrapper__c8GNP`,
	"cardWrapperLarge": `PromoCard_cardWrapperLarge__upSrq`,
	"cardOuterWrapper": `PromoCard_cardOuterWrapper__InV5I`,
	"cardMain": `PromoCard_cardMain__iEeZH`,
	"cardLargeMain": `PromoCard_cardLargeMain__g1DF-`,
	"cardDismissIcon": `PromoCard_cardDismissIcon__B8cj0`,
	"cardImage": `PromoCard_cardImage__G-oWn`,
	"cardImageLarge": `PromoCard_cardImageLarge__VSrHO`,
	"cardIconContainer": `PromoCard_cardIconContainer__qA-VC`,
	"cardIcon": `PromoCard_cardIcon__INJYV`,
	"cardIconImage": `PromoCard_cardIconImage__JWvIz`,
	"cardTitle": `PromoCard_cardTitle__ssr4n`,
	"cardLargeTitle": `PromoCard_cardLargeTitle__Hbdns`,
	"cardLargeSubtitle": `PromoCard_cardLargeSubtitle__KmO7f`,
	"cardAction": `PromoCard_cardAction__HX0Wy`
};
export default ___CSS_LOADER_EXPORT___;
